// ============================================================================
// roomName.js — a szoba megjelenített neve (2026-10-10; chatView.js-ből kiemelve, hogy az admin felület is
// ugyanezt használja körkörös importálás nélkül).
// ============================================================================

import { t } from "./i18n.js";

/**
 * A szoba megjelenítendő neve a tartalomnyelven.
 * Ha a szobának van lokalizált neve a felhasználó nyelvén, azt mutatja;
 * különben az alap nevet (amit az admin megadott).
 */
export function getRoomDisplayName(room, contentLang, uiLang) {
  if (!room) return "";
  const localized = room.localizedNames && room.localizedNames[contentLang];
  return localized || room.name || t(uiLang, "room.noName");
}
